export interface ProfileName {
  first: string;
  last: string;
}

export const EMPTY_NAME: ProfileName = { first: '', last: '' };

export function parseName(raw: unknown): ProfileName | null {
  if (typeof raw !== 'string' || raw === '') return null;
  try {
    const v: unknown = JSON.parse(raw);
    if (typeof v !== 'object' || v === null) return null;
    const { first, last } = v as Partial<ProfileName>;
    return {
      first: typeof first === 'string' ? first : '',
      last: typeof last === 'string' ? last : '',
    };
  } catch {
    return null;
  }
}

export const cleanName = (s: string): string =>
  s
    .replace(/[^\p{L}\p{N}'‘’\- ]/gu, '')
    .replace(/\s+/g, ' ')
    .trim();

export function resolveName(stored: ProfileName | null, tg: ProfileName): ProfileName {
  return {
    first: stored?.first.trim() || cleanName(tg.first),
    last: stored?.last.trim() || cleanName(tg.last),
  };
}
